import { TableCell, TableRow } from '@mui/material';
import React from 'react'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const LuggageTableHeader = ({ columnDefs, UseToPayAsCOD }) => {
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback

  const modifiedColumns = columnDefs
    .map(col => {
      let headerName = tr(col.translationKey, col.headerName)
      if (UseToPayAsCOD === 1) {
        if (col.field === "IsTopay") headerName = tr('gsCod', 'COD')
        if (col.field === "IsTopayMan") headerName = tr('gsCodManual', 'COD Manual')
        if (col.field === "IsDDDV") headerName = tr('gsCodDddv', 'COD DDDV')
      }
      return { ...col, headerName }
    });

  return (
    <TableRow>
      {modifiedColumns.map((col, index) => (
        <TableCell
          key={`TH-${index}`}
          style={{
            ...col.headerSx,
            backgroundColor: '#DAEDFE',
            minHeight: '36px',
            fontSize: '12px',
            fontWeight: '600',
            color: '#444',
          }}
        >
          {col.headerName}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default LuggageTableHeader;
